import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  Toast,
  Checkbox,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
  Select as PolarisSelect,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Pagination from "@mui/material/Pagination";
import moment from "moment";

const Users = () => {
  const navigate = useNavigate();
  const addEditState = useRef("");
  const [isSaving, setIsSaving] = useState(false);
  const perPage = 100;
  const [ts, setTs] = useState("");
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageObject, setPageObject] = useState({
    isLoading: true,
    isSaving: false,
    tableItems: [],
    tableTotalPages: 0,
    isListEmpty: false,
  });
  const handleAddUser = () => {
    navigate("/admin/settings/users-and-permissions/new");
  };
  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    {
      key: "availability",
      label: "Filter by",
      filter: (
        <ChoiceList
          title="Filter by"
          titleHidden
          choices={[
            { label: "Name", value: "name" },
            { label: "Email", value: "email" },
          ]}
          selected={availability || []}
          onChange={handleAvailabilityChange}
        />
      ),
      shortcut: false,
    },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = pageObject.isLoading ? <Loading /> : null;
  const emtyState = pageObject.isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="bodyLg" as="p">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    pageObject.isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const [optionsUniversities, setOptionsUniversities] = useState([]);
  const [selectedUniversity, setSelectedUniversity] = useState("");
  const handleSelectChangeUniversity = (newValue) => {
    refBoolPage.current = false;
    setSelectedUniversity(newValue);
  };
  // University change modal.
  const [editingUser, setEditingUser] = useState(null);
  const [editingUniversity, setEditingUniversity] = useState("");
  const [universityError, setUniversityError] = useState("");
  const openUniversityModal = (user) => {
    setEditingUser(user);
    setEditingUniversity(
      user?.academic_profile?.university_id
        ? String(user.academic_profile.university_id)
        : ""
    );
    setUniversityError("");
  };
  const handleSaveUniversity = () => {
    setIsSaving(true);
    setUniversityError("");
    axios
      .patch(`/users/${editingUser.id}/academic-profile`, {
        university_id: editingUniversity === "" ? null : editingUniversity,
      })
      .then(() => {
        setIsSaving(false);
        setEditingUser(null);
        setToastContent("University updated");
        toggleActive();
        setTs(+new Date());
      })
      .catch((err) => {
        setIsSaving(false);
        setUniversityError(
          err?.response?.data?.message || "Could not update the university."
        );
      });
  };

  // Universities only need loading once.
  useEffect(() => {
    axios
      .get(`/universities?per_page=200`)
      .then((result) =>
        setOptionsUniversities(
          result.data.data.data.map((item) => ({
            label: getFirstNonNullValue(item.name),
            value: String(item.id),
          }))
        )
      )
      .catch((error) => console.log(error));
  }, []);
  const handleEdit = (id) => {
    navigate(`/admin/settings/users-and-permissions/${id}`);
  };
  const handleClickRow = (param) => {
    window.open(`/admin/users/${param}`, "_blank");
  };
  useEffect(() => {
    fetchData();
  }, [ts, availability, queryValue, page, selectedUniversity]);

  async function fetchData() {
    let responseUsers = "";
    let responseFeatures = [];

    try {
      responseUsers = await axios.get(
        `/users?per_page=${perPage}&page=${refBoolPage.current ? page : 1}${
          queryValue
            ? `&filter[${
                availability === "" ? "email" : availability
              }]=${queryValue}`
            : ""
        }${
          selectedUniversity
            ? `&filter[university_id]=${selectedUniversity}`
            : ""
        }`
      );
      setPageObject({
        ...pageObject,
        tableItems: responseUsers.data.data.data.map((item, index) => [
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.id}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.image ? (
              <Thumbnail size="extraSmall" source={item.image} />
            ) : (
              "-"
            )}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.name ? item.name : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.email ? item.email : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.phone ? item.phone : "-"}
          </div>,
          item?.academic_profile?.university
            ? getFirstNonNullValue(item.academic_profile.university.name)
            : "-",
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.created_at
              ? moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss")
              : "-"}
          </div>,

          <ButtonGroup>
            <Button onClick={() => openUniversityModal(item)}>
              Change university
            </Button>
            <Button
              onClick={() => handleDelete(item.id)}
              variant="primary"
              tone="critical"
            >
              Delete
            </Button>
          </ButtonGroup>,
        ]),
        isLoading: false,
        isListEmpty: !responseUsers.data.data.data.length ? true : false,
        tableTotalPages: responseUsers.data.data.total,
      });
    } catch (error) {
      console.log(error);
    }

    // if (!featuresList.length)
    //   try {
    //     responseFeatures = await axios.get(`features`);
    //     setFeaturesList(
    //       responseFeatures.data.data.data.map((item, index) => {
    //         return {
    //           label: item.name,
    //           value: item.id,
    //         };
    //       })
    //     );
    //   } catch (error) {
    //     console.log(error);
    //   }
  }

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This user has been successfully deleted"
  );

  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const refId = useRef(null);
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    refId.current = id;
    setActiveDelete(true);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`users/${refId.current}`)
      .then((result) => {
        setToastContent("This user has been successfully deleted");
        toggleActive();
        setIsSaving(false);
        setActiveDelete(!activeDelete);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  return (
    <Page
      title="Users"
      fullWidth
      // primaryAction={
      //   <Button variant="primary" onClick={handleAddUser}>
      //     Add User
      //   </Button>
      // }
    >
      <Card padding="0">
        {loadingMarkup}

        <div
          style={{
            paddingRight: "1rem",
            paddingLeft: "1rem",
            paddingTop: "0.75rem",
            maxWidth: "320px",
          }}
        >
          <PolarisSelect
            label="University"
            options={[
              { label: "All universities", value: "" },
              ...optionsUniversities,
            ]}
            onChange={handleSelectChangeUniversity}
            value={selectedUniversity}
          />
        </div>

        <Filters
          queryValue={queryValue}
          queryPlaceholder="Search..."
          filters={filters}
          appliedFilters={appliedFilters}
          onQueryChange={handleFiltersQueryChange}
          onQueryClear={handleQueryValueRemove}
          onClearAll={handleFiltersClearAll}
        />

        <DataTable
          columnContentTypes={["text", "text", "text", "text"]}
          headings={[
            <Text variant="bodyMd" as="p" fontWeight="medium">
              ID
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Image
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              User
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Email
            </Text>,

            <Text variant="bodyMd" as="p" fontWeight="medium">
              Phone
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              University
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Created at
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
          ]}
          rows={pageObject.tableItems}
          verticalAlign="middle"
          increasedTableDensity
          footerContent={
            pageObject.tableItems?.length &&
            `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
          }
          hasZebraStripingOnData
        />
        {emtyState}
        {Math.ceil(pageObject.tableTotalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <Pagination
              variant="outlined"
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
            />
            {/* <Pagination
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            /> */}
          </div>
        )}
        <Modal
          open={activeDelete}
          onClose={handleChangeModalDelete}
          title="Delete User"
          primaryAction={{
            content: "Yes",
            onAction: handleYesDelete,
            loading: isSaving,
          }}
          secondaryActions={[
            {
              content: "No",
              loading: isSaving,
              onAction: handleChangeModalDelete,
            },
          ]}
        >
          <Modal.Section>
            <Text>
              <p>Are you sure you want to delete this user?</p>
            </Text>
          </Modal.Section>
        </Modal>
        <Modal
          open={Boolean(editingUser)}
          onClose={() => setEditingUser(null)}
          title="Change university"
          primaryAction={{
            content: "Save",
            onAction: handleSaveUniversity,
            loading: isSaving,
          }}
          secondaryActions={[
            {
              content: "Cancel",
              onAction: () => setEditingUser(null),
            },
          ]}
        >
          <Modal.Section>
            <FormLayout>
              <Text>
                Set the university on <b>{editingUser?.name}</b>'s academic
                profile.
              </Text>
              <PolarisSelect
                label="University"
                options={[
                  { label: "None", value: "" },
                  ...optionsUniversities,
                ]}
                onChange={setEditingUniversity}
                value={editingUniversity}
                error={universityError || undefined}
              />
            </FormLayout>
          </Modal.Section>
        </Modal>

        {toastMarkup}
      </Card>
    </Page>
  );
  function getFirstNonNullValue(obj) {
    if (typeof obj === "string") return obj;
    for (const value of Object.values(obj || {})) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
};

export default Users;
